export default __webpack_public_path__ + "static/media/litho-inner-page-slider-04.fded2dba.jpg";